import en from './en-EU';

export default {
  en,
};
